var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item flex align-items-center"},[_vm._m(0),_c('el-input',{attrs:{"id":"selectRole","maxlength":"50","show-word-limit":"","placeholder":"请输入名称"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item-label"},[_c('span',{staticClass:"red"},[_vm._v("*")]),_vm._v("药品名称 ")])
}]

export { render, staticRenderFns }